import { useNavigate } from "react-router-dom"

import style from "./styles.module.scss"

import { Icon } from "components/Icon"

interface ButtonProps {
    label: string
    onClick: () => void
}

function Button({ label, onClick }: ButtonProps) {
    return (
        <button onClick={onClick} className={style.container}>
            <Icon type="arrow-left-green" size={24} className={style.arrow} />
            {label}
        </button>
    )
}

interface BackButtonProps {
    label: string
    onClick: () => void
}

export function BackButton({ label, onClick }: BackButtonProps) {
    return <Button label={label} onClick={onClick} />
}

export function BackButtonWithHistory() {
    const navigate = useNavigate()

    const hasHistory = history.length > 1

    const handleClickButton = () => {
        if (hasHistory) {
            navigate(-1)
        }
    }

    if (!hasHistory) {
        return null
    }

    return <Button label="Назад" onClick={handleClickButton} />
}
